import { render, staticRenderFns } from "./NewTemplateForm.vue?vue&type=template&id=8ca8fec6&scoped=true&"
import script from "./NewTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./NewTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewTemplateForm.vue?vue&type=style&index=0&id=8ca8fec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca8fec6",
  null
  
)

export default component.exports